import service from 'service';

export const getQR = () => {
  const url = '/core-auth/mfa/qr';
  return service.get(url);
};

export const mfaSetup = ({ type, ...rest }) => {
  const url = `/core-auth/mfa/${type}`;
  return service.post(url, rest);
};
